import { observer } from 'mobx-react-lite';
import { Grid, Stack } from '@mui/material';
import { filter, get } from 'lodash';

import { useRootStore } from 'stores/RootStore';

import ExpenseForecastCard from './ExpenseForecastCard';
import { EntryMode, ExpenseForecast } from 'types/underwriting/income-approach/expenses';
import { UnderwritingOutput } from 'types/underwriting/underwriting';
import { EXPENSE_SUMMARIZED_ENTRY_MODE } from 'shared/constants/expenses';
import { DEFAULT_EXPENSES_KEYS } from 'shared/constants/expenses';

const ExpenseForecastPage = observer(({ form }: any) => {
  const { underwritingPageStore } = useRootStore();
  const { underwritingData = {} as UnderwritingOutput } = underwritingPageStore;

  const expenseHistoryEntryMode: EntryMode | undefined = get(
    underwritingData,
    'incomeApproach.expenses.expenseHistoryEntryMode'
  );

  const expenseComps = get(underwritingData, 'incomeApproach.expenses.expenseComps', []);
  const expenseHistory = get(underwritingData, 'incomeApproach.expenses.expenseHistory', []);
  const expenseCategories = get(underwritingData, 'incomeApproach.expenses.expenseCategories', []);
  const expenseForecastsField = form.$('incomeApproach.expenses.expenseForecasts');
  const expenseForecasts: ExpenseForecast[] = expenseForecastsField.value;

  const filteredExpenseForecasts =
    expenseHistoryEntryMode !== EXPENSE_SUMMARIZED_ENTRY_MODE
      ? expenseForecasts
      : filter(expenseForecasts, (expenseForecast: ExpenseForecast) =>
          Object.values(DEFAULT_EXPENSES_KEYS).includes(expenseForecast.key!)
        );

  return (
    <Grid container spacing={3}>
      <Stack spacing={3} sx={{ width: '100%' }}>
        {filteredExpenseForecasts.map((expenseForecast) => {
          const category = expenseCategories.find((category: any) => category.key === expenseForecast.key);
          return category ? (
            <ExpenseForecastCard
              key={expenseForecast.key}
              category={category}
              expenseHistory={expenseHistory}
              expenseComps={expenseComps}
              expenseForecast={expenseForecast}
              form={form}
              underwritingData={underwritingData}
            />
          ) : null;
        })}
      </Stack>
    </Grid>
  );
});

export { ExpenseForecastPage };
